import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LastUpdateComponent } from './last-update.component';

@NgModule({
  declarations: [
    LastUpdateComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LastUpdateComponent
  ]
})
export class LastUpdateModule { }
